import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  getReportSettings,
  updateReportSettings,
} from './ReportSettings.service';
import { useServiceError } from '@/hooks';
import { MatrixSettingsInterface } from './ReportSettings.types';
import { notification } from 'antd';

export function useReportSetings() {
  const query = useQuery(['report-settings'], () => getReportSettings(), {});

  useServiceError(query.error);

  return query;
}

export function useUpdateReportSettings() {
  const queryClient = useQueryClient();

  const query = useMutation(
    (obj: MatrixSettingsInterface) => updateReportSettings(obj),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso!',
          description: 'Configuração de relatório alterada com sucesso!',
        });

        queryClient.invalidateQueries(['report-settings']);
      },
    },
  );

  useServiceError(query.error);

  return query;
}
